import './styles/index.css';
import './styles/index.scss';

import { CssBaseline } from '@mui/material';
import { get } from 'lodash';
import { Suspense, useLayoutEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './Layout';

import AuthenticateFail from './components/AuthenticateFail';
import CustomerLogin from './components/CustomerLogin/CustomerLogin';
import CustomerVerify from './components/Customerverify/CustomerVerify';
import CustomHTML from './components/CustomHTML/CustomHTML';
import DynamicForm from './components/DynamicForm';
import History from './components/History/History';
import LoyaltyInfo from './components/LoyaltyInfo/LoyaltyInfo';
import Profile from './components/MyProfile';
import Home from './components/Offers/Home';
import ActivatedOffers from './components/Offers/OnlyForYou/ActivatedOffers';
import Redeemed from './components/Offers/OnlyForYou/Redeemed';
import PushNotification from './components/PushNotification/PushNotification';
import ReferFriendV3 from './components/ReferFriendV3/ReferFriendV3';
import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions';
import useAppConfig from './hooks/useAppConfig';
import useAppTheme from './hooks/useAppTheme';
import useAuth from './hooks/useAuth';
import { handleDocumentChanges } from './manifest';
import Redirect from './routes/Redirect';
import ROUTE_PATHS from './routes/routesPath';
import { Loader } from './shared/components/UI';
import TicketDesk from './components/TicketDesk';
import Scheme, { JoinScheme, SchemeDetail } from './components/Scheme';

function App() {
  const { setTheme } = useAppTheme();
  const pwaConfig = useAppConfig();
  const authUser = useAuth();

  useLayoutEffect(() => {
    if (pwaConfig?.appConfig?.config) {
      const { typography, palette } = pwaConfig?.appConfig?.config;
      setTheme({
        typography: { fontFamily: typography?.fontFamily },
        palette: {
          primary: {
            main: palette?.primary,
          },
          secondary: { main: palette?.sideNav.background },
          text: { secondary: palette?.sideNav.textColor },
        },
      });
      handleDocumentChanges({
        tenant: get(authUser, 'user.tenantId'),
        logo: get(pwaConfig, 'appConfig.config.logo'),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pwaConfig?.appConfig?.config]);

  return (
    <Suspense fallback={<Loader />}>
      <CssBaseline />
      <Routes>
        <Route element={<Layout />}>
          <Route path={ROUTE_PATHS.HOME} element={<Profile />} />
          <Route path={ROUTE_PATHS.LOYALTY_INFO} element={<LoyaltyInfo />} />
          <Route path={ROUTE_PATHS.TRANSACTION_HISTORY} element={<History />} />
          <Route path={ROUTE_PATHS.TICKET_DESK} element={<TicketDesk />} />
          <Route path={ROUTE_PATHS.SCHEME} element={<Scheme />} />
          <Route path={ROUTE_PATHS.SCHEME_JOIN} element={<JoinScheme />} />
          <Route path={ROUTE_PATHS.SCHEME_DETAIL} element={<SchemeDetail />} />
          <Route
            path={ROUTE_PATHS.REFER_FRIEND_PWA}
            element={<ReferFriendV3 />}
          />
          <Route path={ROUTE_PATHS.HTML} element={<CustomHTML />} />
          <Route
            path={ROUTE_PATHS.TERMS_AND_CONDITIONS}
            element={<TermsAndConditions />}
          />
          <Route path={ROUTE_PATHS.OFFERS} element={<Home />}>
            <Route
              index 
              element={<Navigate to={ROUTE_PATHS.AVAILABLE_OFFERS} replace />}
            />
            <Route
              path={ROUTE_PATHS.AVAILABLE_OFFERS}
              element={<ActivatedOffers />}
            />
            <Route path={ROUTE_PATHS.REEDEMED_OFFERS} element={<Redeemed />} />
          </Route>
        </Route>
        <Route path={ROUTE_PATHS.ERROR} element={<AuthenticateFail />} />
        <Route path={ROUTE_PATHS.REGISTER} element={<Redirect />} />
        <Route path={ROUTE_PATHS.SIGN_UP} element={<DynamicForm />} />
        <Route path={ROUTE_PATHS.QR_REDIRECT} element={<CustomerVerify />} />
        <Route
          path={ROUTE_PATHS.REFER_FRIEND_PWA}
          element={<ReferFriendV3 />}
        />
        <Route path={ROUTE_PATHS.CUSTOMER_LOGIN} element={<CustomerLogin />} />
        <Route
          path={ROUTE_PATHS.SIGN_UP_SHORTENED}
          element={<CustomerVerify />}
        />
      </Routes>
      <PushNotification />
    </Suspense>
  );
}

export default App;
